export default __webpack_public_path__ + "static/media/analyse.e791f325.svg";